import React from "react";
import MailingResources from "../../components/fullfillment/mailing-resources";

export const Pastoral = () => {
  return (
<MailingResources source={'pastoral'} status='New'/>
  );
};

export default Pastoral;